// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import apis from './../until/api.js'
import ElementUI from 'element-ui'
//Vue.prototype.$baseUrl = "http://143.64.43.85:8083/jinxin/webapi/"
Vue.prototype.$baseUrl = "https://www.jinxin1951.cn/jinxin/webapi/"

// router.beforeEach((to, from, next) => {
//   /* 路由发生变化修改页面title */
//   if (to.meta.title) {
//     document.title = to.meta.title
//   }
//   next()
// })


import 'element-ui/lib/theme-chalk/index.css'
// 公共头部
import CrmHeader from './components/CrmHeader.vue'
import footer from './components/footer.vue'
import indexOne from './components/indexOne.vue'
import indexTwo from './components/indexTwo.vue'
import indexFour from './components/indexFour.vue'
import indexFive from './components/indexFive.vue'
import indexsix from './components/indexsix.vue'


Vue.prototype.$api = apis
Vue.use(ElementUI)
Vue.component('CrmHeader', CrmHeader);
Vue.component('Footer', footer);
Vue.component('indexOne', indexOne);
Vue.component('indexTwo', indexTwo);
Vue.component('indexFour', indexFour);
Vue.component('indexFive', indexFive);
Vue.component('indexsix', indexsix);


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})



// WEBPACK FOOTER //
// ./src/main.js